import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "./ReviewSlider.css";

const reviews = [
  {
    image:
      "https://lh3.googleusercontent.com/a/ACg8ocJfYbe8oM2fnvslHyNsvQJ6Nz0PmLTu5X6yIbAdiO1IHSTxFw=w72-h72-p-rp-mo-br100",
    name: "Micaela Piceda",
    text: "Lleve mi celu hace unas semanas y quedó perfecto, gracias Alan el técnico un genio y amable , súper recomendable🤗…",
    rating: 5,
  },
  {
    image:
      "https://lh3.googleusercontent.com/a/ACg8ocKJ_56gxDcvZYhETq6NtvalLLIkYJXAE63X81EsQJGE50syDaI=w36-h36-p-rp-mo-br100",
    name: "Lucas Suarez",
    text: "Excelente la atención, llevé a reparar mi celu por pantalla rota y no solo fue rápido sino también el precio acorde. Más que satisfecho!",
    rating: 5,
  },
  {
    image:
      "https://lh3.googleusercontent.com/a/ACg8ocINN_QkanKYtxMr1ir1mGTXhZQ_ugETNSv3XZsXT2OW6SYu_A=w36-h36-p-rp-mo-br100",
    name: "Elvira Maidana",
    text: "Excelente servicio, me reparo el celular y quedó muy bien, una atención profesional",
    rating: 5,
  },
  {
    image:
      "https://lh3.googleusercontent.com/a/ACg8ocIoXqmjn-w9U-CuPbSJ8JbvPlL74quTP7BGuSIeNbzrsJRCEg=w36-h36-p-rp-mo-br100",
    name: "Sandra Aquino",
    text: "Lleve mi celu a reparar, muy buena la atención y sobretodo rápido!",
    rating: 5,
  },
];

const averageRating =
  reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length;

const ReviewSlider = () => {
  const shouldAutoplay = reviews.length > 4;
  const [imgErrors, setImgErrors] = useState({});

  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>
          <strong>Opiniones de Clientes</strong>
        </h2>

        <div className="reviews-rating">
          <span>★★★★★</span>
          <p>{averageRating.toFixed(1)} / 5</p>
        </div>

        <a
          href="https://www.google.com/maps/place/TecniPlus%2B/@-32.9668398,-60.6729097,19.83z/data=!4m8!3m7!1s0x95b7ab0000368e23:0x46e5328811d84825!8m2!3d-32.9668611!4d-60.6727075!9m1!1b1!16s%2Fg%2F11nb7nfp6y?entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noreferrer"
        >
          Ver todas las opiniones en Google
        </a>
      </div>

      <div className="reviews-container">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          autoplay={
            shouldAutoplay
              ? { delay: 2500, disableOnInteraction: false }
              : false
          }
          loop={shouldAutoplay}
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="review-card">
                <div className="stars">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <span key={i}>★</span>
                  ))}
                </div>

                <p className="review-text">"{review.text}"</p>

                <div className="review-user">
                  <div className="avatar">
                    {!imgErrors[index] ? (
                      <img
                        src={review.image}
                        alt={review.name}
                        onError={() =>
                          setImgErrors((prev) => ({
                            ...prev,
                            [index]: true,
                          }))
                        }
                      />
                    ) : (
                      review.name.charAt(0)
                    )}
                  </div>

                  <span>{review.name}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ReviewSlider;
